<template>
  <div>
    <b-row class="align-items-end">
      <b-col md="6" lg="3">
        <SelectIssExibility
          id="issExibility"
          :clearable="false"
          v-model="nfseConfigurations.issExibility"
        />
      </b-col>
      <b-col md="6" lg="3">
        <SelectTaxRegime
          id="taxRegime"
          :clearable="false"
          v-model="nfseConfigurations.taxRegime"
        />
      </b-col>
      <b-col>
        <Input
          label="Cód. de tributação do município"
          labelBold
          id="cityTaxCode"
          :maxlength="10"
          v-model="nfseConfigurations.cityTaxCode"
        />
      </b-col>
      <b-col lg="3" class="text-center">
        <b-col><Label>Incentivador Cultural</Label></b-col>
        <b-row>
          <b-col
            ><CheckboxSwitch
              id="culturalEncouraging"
              v-model="nfseConfigurations.culturalEncouraging"
              :tooltipPosition="'bottom'"
          /></b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <SelectNBS
          id="cityServiceListItem"
          :clearable="false"
          v-model="nfseConfigurations.cityServiceListItem"
        />
      </b-col>
      <b-col md="6" lg="3">
        <Input
          label="Código"
          labelBold
          disabled
          :value="cityServiceListItemCode"
        />
      </b-col>
      <b-col lg="3" class="text-center">
        <b-col><Label>Enviar CNAE zerado</Label></b-col>
        <b-row>
          <b-col
            ><CheckboxSwitch
              id="culturalEncouraging"
              v-model="nfseConfigurations.sendZeroedCnae"
              :tooltipPosition="'bottom'"
          /></b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { SelectIssExibility, SelectTaxRegime, SelectNBS } from '@/components';
import { CheckboxSwitch, Label, Input } from '@/components/Form';
import { mapState } from 'vuex';

export default {
  name: 'General',
  components: {
    SelectIssExibility,
    SelectTaxRegime,
    SelectNBS,
    CheckboxSwitch,
    Label,
    Input,
  },
  computed: {
    ...mapState('nfseConfigurations', ['nfseConfigurations']),

    cityServiceListItemCode() {
      return this.nfseConfigurations.cityServiceListItem?.code ?? null;
    },
  },
};
</script>
